<template>
  <el-dialog
    title="设备白名单"
    :visible.sync="visible"
    width="700px"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <el-table :data="dataList" v-loading="tabLoding" border>
      <el-table-column
        prop="deviceName"
        header-align="center"
        align="center"
        label="设备名称"
      >
      </el-table-column>
      <el-table-column
        prop="uniqueAddress"
        header-align="center"
        align="center"
        label="设备唯一凭证"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        header-align="center"
        align="center"
        label="备注"
      >
        <template slot-scope="scope">
          {{ scope.row.remark || '-' }}
        </template>
      </el-table-column>
    </el-table>
    <div v-if="totalPage > 0">
      <el-pagination
        class="mt-sm"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import httpMethods from '@/api/equipment/http.js'
export default {
  data() {
    return {
      dataForm: {
        name: ''
      },
      visible: false,
      proId: '',
      tabLoding: false,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataList: []
    }
  },
  components: {},

  mounted() {
    this.querySearch()
  },
  methods: {
    querySearch() {
      this.pageIndex = 1
      this.getDataList()
    },

    getDataList() {
      const params = {
        productId: this.proId,
        currentPage: this.pageIndex,
        size: this.pageSize
      }
      httpMethods
        .getDataList(params)
        .then((res) => {
          const data = res.data
          if (data && res.resp_code === 0) {
            if (data.list.length === 0 && data.total > 0) {
              this.pageIndex = this.pageIndex - 1
              this.getDataList()
            } else {
              this.dataList = data.list
              this.totalPage = data.total
            }
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.tabLoding = false
        })
        .catch(() => {
          this.dataList = []
          this.totalPage = 0
          this.tabLoding = false
        })
    },
    init(info) {
      this.visible = true
      this.$nextTick(() => {
        this.proId = info.id
        this.getDataList()
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
